export default __webpack_public_path__ + "static/media/Example-Invoice.d9ef5dbd.png";